import * as React from 'react'
import type { SVGProps } from 'react'
const SvgSpotify = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 1C5.9506 1 1 5.9506 1 12c0 6.0506 4.9506 11 11 11 6.0506 0 11-4.9494 11-11 0-6.0494-4.8953-11-11-11m5.06 15.8953c-.22.3294-.6047.44-.9353.22-2.5847-1.5953-5.8294-1.9247-9.68-1.0447-.3847.1094-.7141-.1659-.8247-.4964-.1106-.3836.1647-.7142.4953-.8236 4.18-.9364 7.8094-.5506 10.6694 1.2094.3847.1647.44.6047.2753.9353m1.32-3.0247c-.2753.3836-.7706.5494-1.1553.2741C14.2553 12.3306 9.7447 11.78 6.28 12.88c-.44.1106-.9353-.1106-1.0447-.5494-.1106-.44.1094-.9364.5494-1.0459C9.8 10.0753 14.7506 10.68 18.16 12.7694c.3306.1659.4953.7153.22 1.1012m.1106-3.08C14.9706 8.7 9.0847 8.48 5.7306 9.5247a1.0323 1.0323 0 0 1-1.2659-.66 1.0323 1.0323 0 0 1 .66-1.2647c3.9059-1.1553 10.34-.9353 14.4106 1.4847.4953.2753.66.9353.3847 1.4306-.2753.3847-.9353.5494-1.4294.2753"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgSpotify
